import { Injectable } from '@angular/core';

import { GqlServiceV2 } from '../modules/content/service/gql.service-v2';
import { GridInput } from '@it2go/data-grid';
import { WarehouseMaterialGridObject, WarehouseMaterialObject } from '@libs/types/src/services/object-type/service/social-service/warehouse-material.object';
import { WarehouseMaterialCreateInput } from '@libs/types/src/services/input-type/services/social-service/warehouse-material.create-input';
import { WarehouseMaterialPatchInput } from '@libs/types/src/services/input-type/services/social-service/warehouse-material.patch-input';
import { IdInput } from '@libs/types/src/common/input-type/id.input';
import { OkObject } from '@it2go/types';
import { filterFrag } from './types/filter.types';

@Injectable({ providedIn: 'root' })
export class WarehouseMaterialGqlService extends GqlServiceV2 {

    public getWarehouseMaterials(input: GridInput | null, frag: string) {
        return this.query<WarehouseMaterialGridObject>(
            `
                query($input: GridInput!) {
                    warehouseMaterial {
                        filter(input: $input) {
                            ${filterFrag}
                            items {
                                ${frag}
                            }
                        }
                    }
                }
            `,
            { input },
        );
    }

    public createWarehouseMaterial(input: WarehouseMaterialCreateInput, frag: string) {
        return this.mutate<WarehouseMaterialObject>(
            `
                mutation($input: WarehouseMaterialCreateInput!) {
                    warehouseMaterial {
                        create(input: $input) {
                            ${frag}
                        }
                    }
                }
            `,
            { input },
        );
    }

    public patchWarehouseMaterial(input: WarehouseMaterialPatchInput, frag: string) {
        return this.mutate<WarehouseMaterialObject>(
            `
                mutation($input: WarehouseMaterialPatchInput!) {
                    warehouseMaterial {
                        patch(input: $input) {
                            ${frag}
                        }
                    }
                }
            `,
            { input },
        );
    }

    public deleteWarehouseMaterial(input: IdInput, frag = 'ok') {
        return this.mutate<OkObject>(
            `
                mutation($input: IdInput!) {
                    warehouseMaterial {
                        delete(input: $input) {
                            ${frag}
                        }
                    }
                }
            `,
            { input },
        );
    }
}
